import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

import moment from "moment";
import { IWeekendgateways } from "../weekendgatewaysModel";

export const createWeekendgateways = createAsyncThunk(
  "WeekendGateway/InsertWeekendGateway",
  async (WeekendgatewaysData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeekendGateway/InsertWeekendGateway`,
        WeekendgatewaysData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Weekendgateways:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateWeekendgateways = createAsyncThunk(
  "WeekendGateway/UpdateWeekendGateway",
  async (WeekendgatewaysData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeekendGateway/UpdateWeekendGateway`,
        WeekendgatewaysData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Weekendgateways :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteWeekendgateways = createAsyncThunk(
  "WeekendGateway/DeleteWeekendGateway",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeekendGateway/DeleteWeekendGateway`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Weekendgateways :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getWeekendgatewaysByID = createAsyncThunk(
  "WeekendGateway/FindByIDWeekendGateway",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeekendGateway/FindByIDWeekendGateway`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Name: result.Name,
        DisplayName: result.DisplayName,
        ShortDescription: result.ShortDescription,
        LongDescription: result.LongDescription,
        NoofNights: result.NoofNights,
        Description: result.Description,
        Star: result.Star,
        MetaTitle: result.MetaTitle,
        MetaKeywords: result.MetaKeywords,
        MetaDescription: result.MetaDescription,
        DestinationID: result.DestinationID,
        PerCoupleRate: result.PerCoupleRate,
        ExtraAdultRate: result.ExtraAdultRate,
        ExtraChildRateWithoutBed: result.ExtraChildRateWithoutBed,
        ExtraChildRateWithBed: result.ExtraChildRateWithBed,
        SpecialRate: result.SpecialRate,
        Inclusions: result.Inclusions,
        TourInfo: result.TourInfo,
        Activities: result.Activities,
        MainImage: result.MainImage,

        InnerImages:
          result.InnerImages?.map((img: any) => ({
            ID: img.ID,
            InnerImage: img.InnerImage,
          })) || [],

        FromDate: result.FromDate
          ? moment(result.FromDate, "YYYY-MM-DD").toDate()
          : "",
        ToDate: result.ToDate
          ? moment(result.ToDate, "YYYY-MM-DD").toDate()
          : "",
        // CWBRate: result.CWBRate,
        // CoupleRate: result.CoupleRate,
        // CNBRate: result.CNBRate,
        ActivityID: result.ActivityID
          ? result.ActivityID?.split(",")?.map((id: any) => Number(id))
          : [],
        IsActive: result.IsActive,
      } as IWeekendgateways;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Weekendgateways :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveWeekendgateways = createAsyncThunk(
  "WeekendGateway/FindAllActiveWeekendGateway",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/WeekendGateway/FindAllActiveWeekendGateway`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Weekendgateways:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveWeekendgateways = createAsyncThunk(
  "WeekendGateway/ActiveInActiveWeekendGateway",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeekendGateway/ActiveInActiveWeekendGateway`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Weekendgateways :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const WeekendgatewaysImageUpload = createAsyncThunk(
  "WeekendGateway/WeekendGatewayImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeekendGateway/WeekendGatewayImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Weekendgateways Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteWeekendgatewaysImage = createAsyncThunk(
  "WeekendGateway/DeleteWeekendGatewayImage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeekendGateway/DeleteWeekendGatewayImage`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Weekendgateways :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
